export default __webpack_public_path__ + "static/alkemi-logo-56027a09bfc275ef942d417c94b68b7a.svg";